import axios from 'axios';

import config from '../common/config';

export default {
  addAttractionToRide( token, rideId, attractionId, date, shouldCopyTheAttraction ) {
    const formData = new FormData()
    formData.append('date', date);
    formData.append('shouldCopyTheAttraction', shouldCopyTheAttraction);
    return axios.post(`${config.config.ROOT_URL}/add_attraction_to_ride_api/${rideId}/${attractionId}`,formData, {
      headers: {
        'Authorization': `Bearer ${token}`,
        'content-type': 'multipart/form-data',
      }
    });
  },

  addAttractionFromImageToRide( token, atractionMetadataList ) {
    const formData = new FormData()
    formData.append('data', JSON.stringify(atractionMetadataList));
    return axios.post(`${config.config.ROOT_URL}/add_attraction_from_image_to_ride_api`,formData, {
      headers: {
        'Authorization': `Bearer ${token}`,
        'content-type': 'multipart/form-data'        }
    });
  },

  updateAttractionRideTime( token, rideId, attractionId, date ) {
    return axios.get(`${config.config.ROOT_URL}/update_attraction_ride_time_api/${rideId}/${attractionId}`, {
      headers: {
        Authorization: `Bearer ${token}`,
        data: date
      }
    });
  },

  addgooglePlaceToRide( token, rideId, googlePlaceId, date ) {
    return axios.get(`${config.config.ROOT_URL}/add_google_attraction_to_ride_api/${rideId}/${googlePlaceId}`, {
      headers: {
        Authorization: `Bearer ${token}`,
        data: date
      }
    });
  },
  removeAttractionFromRide( token, rideId, attractionId ) {
    return axios.get(`${config.config.ROOT_URL}/remove_attraction_from_ride_api/${rideId}/${attractionId}`, {
      headers: {
        Authorization: `Bearer ${token}`
      }
    });
  },
  addNewDayToRide( token, rideId, dayIndex, force = false ) {
    const url = force 
      ? `${config.config.ROOT_URL}/add_day_to_ride_api/${rideId}/${dayIndex}/force`
      : `${config.config.ROOT_URL}/add_day_to_ride_api/${rideId}/${dayIndex}`;
    
    return axios.get(url, {
      headers: {
        'Authorization': `Bearer ${token}`
      }
    });
  },
  updateRideDuration( token, rideId, newRideDates ) {
    const formData = new FormData()
    formData.append('data', JSON.stringify(newRideDates));
    return axios.post(`${config.config.ROOT_URL}/update_ride_duration_api/${rideId}`, formData, {
      headers: {
        'Authorization': `Bearer ${token}`,
        'content-type': 'multipart/form-data'        
      }
    });
  },

  removeDayFromRide( token, rideId, dayIndex, force = false ) {
    const url = force 
      ? `${config.config.ROOT_URL}/remove_day_from_ride_api/${rideId}/${dayIndex}/force`
      : `${config.config.ROOT_URL}/remove_day_from_ride_api/${rideId}/${dayIndex}`;
    
    return axios.get(url, {
      headers: {
        'Authorization': `Bearer ${token}`
      }
    });
  },
  removeDayAndAttractionsFromRide( token, rideId, dayIndex, force = false ) {
    const url = force 
      ? `${config.config.ROOT_URL}/remove_day_and_attractions_from_ride_api/${rideId}/${dayIndex}/force`
      : `${config.config.ROOT_URL}/remove_day_and_attractions_from_ride_api/${rideId}/${dayIndex}`;
    
    return axios.get(url, {
      headers: {
        'Authorization': `Bearer ${token}`
      }
    });
  },
  // Move all attractions of a specific day to a new date (attractionNewTime).
  // The backend endpoint expects the new date as part of the URL path and the original
  // day index as a query-string parameter.
  moveDayAttractions( token, rideId, dayIndex, attractionNewTime ) {
    return axios.get(
      `${config.config.ROOT_URL}/move_day_attractions_by_date_api/${rideId}/${dayIndex}`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
          data: attractionNewTime
        }
      }
    );
  },
  createAttraction( token, rideId, attractionInfo )
    {
      const formData = new FormData()
      formData.append('data', JSON.stringify(attractionInfo));
      return axios.post(`${config.config.ROOT_URL}/create_attraction_and_add_to_ride_api/${rideId}`,formData, {
        headers: {
          'Authorization': `Bearer ${token}`,
          'content-type': 'multipart/form-data'        }
      });
    },
  checkIfUserHasPlaceIdInAttractions(  token, rideId, placeInfo)
    {
      const formData = new FormData()
      formData.append('data', JSON.stringify(placeInfo));
      return axios.post(`${config.config.ROOT_URL}/check_if_user_has_place_id_in_attractions_api/${rideId}`,formData, {
        headers: {
          'Authorization': `Bearer ${token}`,
          'content-type': 'multipart/form-data'        }
      });
      // response.data.userAttractionCheckResult = {
      //     "has_attraction_with_place_id": False,
      //     "is_assigned_to_this_ride": False,
      //     "lat": None,
      //     "lng": None
      // }
    },

  updateRideCategory( token, rideId,category ){
    const formData = new FormData()
    formData.append('data', JSON.stringify(category));
    return axios.post(`${config.config.ROOT_URL}/update_ride_category_api/${rideId}`,formData, {
      headers: {
        'Authorization': `Bearer ${token}`,
        'content-type': 'multipart/form-data'        }
    });

  },

  resetRideToCopiedRideApi( token, rideId ) {
    return axios.get(`${config.config.ROOT_URL}/reset_ride_to_original_order_api/${rideId}`, {
      headers: {
        'Authorization': `Bearer ${token}`
      }
    });
  },



};